const DependencyBoxLoading = () => {
    return (
        <>
            {
                [...Array(8)].map((_, i) => (
                    <div
                        key={i}
                        className="bg-white dependance-card w-full rounded transition overflow-hidden p-0"
                        style={{
                            borderRadius: "12px",
                            margin: "10px 5px",
                        }}
                    >
                        <div className="rounded-card-image w-100"></div>
                        <div className="rounded-card-img l-load"></div>
                        <div className="flex justify-center items-center w-full my-3">
                            <div className="w-32 h-3 rounded-lg l-load-dt"></div>
                        </div>
                    </div>
                ))
            }
        </>
    )
}
export default DependencyBoxLoading;